import { render } from "./DeliveryPricingBulkImport.html?vue&type=template&id=69717615&scoped=true"
import script from "./DeliveryPricingBulkImport.js?vue&type=script&lang=js"
export * from "./DeliveryPricingBulkImport.js?vue&type=script&lang=js"

import "./DeliveryPricingBulkImport.css?vue&type=style&index=0&id=69717615&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69717615"]])

export default __exports__